module.exports = __webpack_public_path__ + "img/gauge.da620057.svg";